import { useEffect, useRef } from "react";

// rAF-driven vertical loop (replaces CSS keyframes, which checkerboard on mobile GPUs)
export function useRailLoop(ref, enabled, durationSec, paused = false) {
    const pausedRef = useRef(paused);
    pausedRef.current = paused;

    useEffect(() => {
        const el = ref.current;
        if (!enabled || !el) return;
        let offset = 0;
        let last = performance.now();
        let hovering = false;
        let raf;
        const canHover = window.matchMedia("(hover: hover)").matches;
        const enter = () => (hovering = true);
        const leave = () => (hovering = false);
        if (canHover) {
            el.addEventListener("mouseenter", enter);
            el.addEventListener("mouseleave", leave);
        }
        const tick = (now) => {
            const dt = Math.min(now - last, 100);
            last = now;
            if (!pausedRef.current && !hovering) {
                offset = (offset + dt / (durationSec * 1000)) % 1;
                el.style.transform = `translate3d(0, ${-offset * 50}%, 0)`;
            }
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => {
            cancelAnimationFrame(raf);
            el.removeEventListener("mouseenter", enter);
            el.removeEventListener("mouseleave", leave);
            el.style.transform = "";
        };
    }, [ref, enabled, durationSec]);
}
